export default function PHP_array_push() {
  return (
    <div>
      <h1>PHP_array_push</h1>
    </div>
  );
}
